export default __webpack_public_path__ + "static/media/wale-img.5afe1307.png";